import { render, staticRenderFns } from "./AlbumList.vue?vue&type=template&id=ee5e5faa"
import script from "./AlbumList.vue?vue&type=script&lang=js"
export * from "./AlbumList.vue?vue&type=script&lang=js"
import style0 from "./AlbumList.vue?vue&type=style&index=0&id=ee5e5faa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports